import { render } from "./VideoMessage.vue?vue&type=template&id=581c2062"
import script from "./VideoMessage.vue?vue&type=script&lang=js"
export * from "./VideoMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__